/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_NightlyInputs */

const en_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nightly`)
};

const es_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por noche`)
};

const fr_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la nuit`)
};

const de_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Nacht`)
};

const ja_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1泊あたり`)
};

const zh_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按晚`)
};

const ar_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليلياً`)
};

const id_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per Malam`)
};

const it_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Notte`)
};

const ru_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посуточно`)
};

const pt_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por Noite`)
};

const ko_val_nightly = /** @type {(inputs: Val_NightlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1박당`)
};

/**
* | output |
* | --- |
* | "Nightly" |
*
* @param {Val_NightlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_nightly = /** @type {((inputs?: Val_NightlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_NightlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_nightly(inputs)
	if (locale === "es") return es_val_nightly(inputs)
	if (locale === "fr") return fr_val_nightly(inputs)
	if (locale === "de") return de_val_nightly(inputs)
	if (locale === "ja") return ja_val_nightly(inputs)
	if (locale === "zh") return zh_val_nightly(inputs)
	if (locale === "ar") return ar_val_nightly(inputs)
	if (locale === "id") return id_val_nightly(inputs)
	if (locale === "it") return it_val_nightly(inputs)
	if (locale === "ru") return ru_val_nightly(inputs)
	if (locale === "pt") return pt_val_nightly(inputs)
	return ko_val_nightly(inputs)
});